import styled from "styled-components";

export const StyledWrapper = styled.div`
  width: 100%;
  cursor: pointer;

  * {
    transition: all ease 0.5s;
  }
`;
